<template>
  <label
    :class="['check', { 'disabled': disabled }]"
    @click.prevent="changeState"
  >
    <input
      :name="name"
      :checked="checkboxValue"
      :disabled="disabled"
      class="check__input"
      type="checkbox"
      autocomplete="off"
    >
    <span class="check__box"></span>

    <span class="check__text"></span>
  </label>
</template>

<script>

export default {
  name: 'CustomCheckbox',

  emits: ['checked'],

  props: {
    name: {
      type: String,
      required: false,
    },

    checked: {
      type: Boolean,
      required: false,
      default: false,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      checkboxValue: false,
    };
  },

  watch: {
    checked: {
      handler(value) {
        this.checkboxValue = value;
      },

      immediate: true,

    }
  },

  methods: {
    changeState() {
      if (this.disabled) {
        return;
      }

      this.checkboxValue = !this.checkboxValue;
    }
  }
};
</script>

<style lang="less" scoped>
.check {
  display: flex;
  cursor: pointer;
  user-select: none;
  position: relative;
  width: 18px;
  height: 18px;

  &.disabled {
    pointer-events: none;
  }

  * > {
    box-sizing: border-box;
  }

  &__input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);

    &:disabled {
      pointer-events: none;
      opacity: 0.5;

      &:checked {
        & + .check__box {
          &:after {
            background-color: #808080;
          }

          border-color: #808080;
        }
      }
    }

    &:checked {
      & + .check__box {
        &:after {
          content: '';

          display: flex;

          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-position: center;
          background-color: #3F8EC5;
          border-radius: 3px;
          background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_4880_57515)'%3E%3Cpath d='M4.07573 10.2985L0.175728 6.39852C-0.0585762 6.16421 -0.0585762 5.78431 0.175728 5.54999L1.02424 4.70145C1.25854 4.46713 1.63846 4.46713 1.87277 4.70145L4.49999 7.32866L10.1272 1.70145C10.3615 1.46715 10.7414 1.46715 10.9758 1.70145L11.8243 2.54999C12.0586 2.78429 12.0586 3.16419 11.8243 3.39852L4.92426 10.2985C4.68993 10.5328 4.31003 10.5328 4.07573 10.2985Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_4880_57515'%3E%3Crect width='12' height='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        }
      }
    }
  }

  &__box {
    position: absolute;
    width: 18px;
    height: 18px;

    top: 2px;
    left: 17px;

    background-color: #ffffff;
    border: 1px solid #3F8EC5;
    border-radius: 3px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__text {

  }
}

</style>
